import { Box, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { Button, Heading, colors } from 'ui-components';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

type Props = {
  isConnected: boolean;
  isEmpty: boolean;
  isManager: boolean;
  isBuilder?: boolean;
};
export const EmptyState = ({
  isEmpty,
  isConnected,
  isManager,
  isBuilder = false,
}: Props) => {
  const router = useRouter();
  const slug = router.query.creatorSlug as string;

  const foamTalentRecordChannelMetricsFlags = useFeature(
    FEATURE_FLAGS.foamTalentRecordChannelMetrics,
  );
  const navigateToConnections = () => {
    router.push(`/t/${slug}/platform-connections`);
  };
  return (
    <Flex
      width="100%"
      height="100%"
      position="absolute"
      top={0}
      left={0}
      background={`linear-gradient(transparent,${colors.primary[0]})`}
      alignItems="end"
    >
      <Flex
        maxWidth={708}
        mx="auto"
        justifyContent="center"
        textAlign="center"
        flexDirection="column"
        gap={6}
      >
        {isBuilder ? (
          <Heading size="sm">
            Audience demographics charts are not currently available for this
            Talent. Please try again later.
          </Heading>
        ) : (
          <>
            {foamTalentRecordChannelMetricsFlags.isEnabled && (
              <Heading size="sm">
                {isEmpty &&
                  isConnected &&
                  'Audience demographics charts are not currently available for this Talent. Please try again later.'}
              </Heading>
            )}
            {!foamTalentRecordChannelMetricsFlags.isEnabled && (
              <>
                <Heading size="sm">
                  {!isConnected
                    ? 'Access detailed audience demographic metrics directly from platform APIs by having your Talent connect their social accounts.'
                    : 'Audience Demographics Unavailable'}
                </Heading>
                <Box>
                  {!isConnected ? (
                    isManager ? (
                      <Button size="md" onClick={navigateToConnections}>
                        Connect
                      </Button>
                    ) : null
                  ) : isEmpty ? (
                    <p>
                      Audience demographics charts are not currently available
                      for this Talent. Please try again later.
                    </p>
                  ) : null}
                </Box>
              </>
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
};
